<nav class="navbar bg-primary navbar-dark navbar-expand-lg d-none d-lg-flex shadow position-relative">
  <a
    class="p-0"
    [routerLink]="['/']"
    routerLinkActive="router-link-active"
    attr.aria-label="{{ 'nav.home.page.screenreader' | translate: { fgbdefault: 'Move to home page' } }}"
  >
    <label id="homeLink" class="accessibility-only">{{ 'redirect.home.page' | translate }}</label>
    <img
      alt=""
      aria-labelledby="homeLink"
      width="50"
      height="auto"
      src="assets/images/mytwins-primary-logo.png"
      draggable="false"
    />
  </a>

  <!-- middle Content -->
  <div class="navbar-collapse" [ngbCollapse]="isCollapsed" id="navbarSupportedContent">
    <div class="nav-container">
      <ul class="navbar-nav w-100" #greedyNav>
        <ng-container *inPopulation="[populations.Suite, populations.Pts]">
          <li class="nav-item">
            <a
              class="nav-link text-white"
              [routerLink]="['/account']"
              routerLinkActive="router-link-active"
              attr.aria-label="{{ 'nav.account.screenreader' | translate: { fgbdefault: 'Move to account page' } }}"
              >{{ 'nav.account' | translate }}</a
            >
          </li>
          <li class="nav-item" *inPopulation="[populations.Suite]">
            <a
              class="nav-link text-white"
              [routerLink]="['/partners']"
              routerLinkActive="router-link-active"
              attr.aria-label="{{ 'nav.partner.screenreader' | translate: { fgbdefault: 'Move to partner page' } }}"
              >{{ 'nav.partner' | translate }}</a
            >
          </li>

          <li class="nav-item" *inPopulation="[populations.Pts]">
            <a
              class="nav-link text-white"
              [routerLink]="['/faq']"
              routerLinkActive="router-link-active"
              attr.aria-label="{{ 'nav.partner.screenreader' | translate: { fgbdefault: 'Move to partner page' } }}"
              >{{ 'nav.faq' | translate }}</a
            >
          </li>

          <li class="nav-item">
            <a
              class="nav-link text-white"
              [routerLink]="['/terms']"
              routerLinkActive="router-link-active"
              attr.aria-label="{{ 'nav.terms.screenreader' | translate: { fgbdefault: 'Move to terms page' } }}"
              >{{ 'nav.terms' | translate }}</a
            >
          </li>
        </ng-container>

        <ng-container *inPopulation="[populations.Free, populations.Partner, populations.Default]">
          <li class="nav-item">
            <a
              class="nav-link text-white"
              [routerLink]="['/rewards']"
              routerLinkActive="router-link-active"
              attr.aria-label="{{ 'nav.rewards.screenreader' | translate: { fgbdefault: 'Move to rewards page' } }}"
              >{{ 'nav.rewards' | translate }}</a
            >
          </li>

          <li class="nav-item">
            <a
              class="nav-link text-white"
              [routerLink]="['/games']"
              routerLinkActive="router-link-active"
              attr.aria-label="{{ 'nav.games.screenreader' | translate: { fgbdefault: 'Move to games page' } }}"
              >{{ 'nav.games' | translate }}</a
            >
          </li>
          <li class="nav-item">
            <a
              class="nav-link text-white"
              [routerLink]="['/earn']"
              routerLinkActive="router-link-active"
              attr.aria-label="{{ 'nav.earns.screenreader' | translate: { fgbdefault: 'Move to earns page' } }}"
              >{{ 'nav.earns' | translate }}</a
            >
          </li>

          <li class="nav-item" *notInPopulation="[populations.Partner, populations.Default]">
            <a
              class="nav-link text-white"
              [routerLink]="['/partners']"
              routerLinkActive="router-link-active"
              attr.aria-label="{{ 'nav.partner.screenreader' | translate: { fgbdefault: 'Move to partner page' } }}"
              >{{ 'nav.partner' | translate }}</a
            >
          </li>

          <li class="nav-item" *inPopulation="[populations.Partner, populations.Default]">
            <a
              class="nav-link text-white"
              [routerLink]="['/ecash-transfer']"
              routerLinkActive="router-link-active"
              attr.aria-label="{{ 'nav.partner.screenreader' | translate: { fgbdefault: 'Move to partner page' } }}"
              >{{ 'nav.transfer' | translate }}</a
            >
          </li>

          <li class="nav-item">
            <a
              class="nav-link text-white"
              [routerLink]="['/rewards/wallet']"
              routerLinkActive="router-link-active"
              attr.aria-label="{{ 'nav.wallet.screenreader' | translate: { fgbdefault: 'Move to wallet page' } }}"
              >{{ 'nav.wallet' | translate }}</a
            >
          </li>
        </ng-container>
      </ul>
    </div>
  </div>

  <div class="right-nav-container d-flex flex-row align-items-center justify-content-center">
    <ng-container *inPopulation="[populations.Free, populations.Partner, populations.Default]">
      <div class="balance-container d-flex flex-row align-items-center justify-content-center">
        <div class="balance font-size-14 bg-glass" *ngIf="loyaltyPointsCard$">
          <span class="icons material-icons text-white" aria-hidden="true">loyalty</span>
          <label class="fw-bold text-white"
            >{{ loyaltyPointsCard$ | async | number: '1.0-0' }}
            <span class="font-size-14">{{ 'fgbcl.currency.pts' | translate }}</span>
          </label>
        </div>

        <div class="balance font-size-14 bg-glass" *ngIf="combinedCard$">
          <span class="icons material-symbols-outlined text-white"> money_bag </span>
          <label class="fw-bold text-white">{{ combinedCard$ | async | FortressCurrencyPipe }}</label>
        </div>
      </div>
    </ng-container>

    <button
      class="nav-link btn d-flex align-items-center px-0 justify-content-end text-white"
      (click)="isSideNavOpen = !isSideNavOpen"
      id="namedropdown"
      attr.aria-label="{{ 'nav.account.menu.screenreader' | translate }}"
      tabindex="-1"
      focusTab
    >
      <i class="material-symbols-outlined">menu</i>
    </button>
  </div>
</nav>

<div class="right-nav-menu-overlay" *ngIf="isSideNavOpen" [@rightMenuOverlayAnimation]></div>
<div
  class="right-nav-menu bg-primary shadow"
  [@rightNavAnimation]="isSideNavOpen ? 'open' : 'close'"
  [ngClass]="{ open: isSideNavOpen }"
>
  <div class="d-flex flex-column h-100">
    <!-- Close Button -->
    <button type="button" class="close-button position-absolute" (click)="isSideNavOpen = false" aria-label="Close">
      <i class="material-icons close-btn">close</i>
    </button>

    <!-- Club Logo -->
    <div class="d-flex align-items-center justify-content-start brand-logo">
      <img
        alt=""
        aria-labelledby="homeLink"
        width="40"
        height="auto"
        src="assets/images/mytwins-primary-logo.png"
        draggable="false"
      />
    </div>

    <div class="modal-content d-flex gap-2 rounded-0">
      <div class="modal-header w-100">
        <div
          class="card-name fw-bold text-uppercase font-size-20 font-heading text-white"
          *ngIf="memberDetails$ | async as memberDetails"
        >
          {{ memberDetails.FirstName }} {{ memberDetails.Surname }}
        </div>
        <div
          class="account-num-header font-sie-14 d-flex flex-row align-items-center text-white"
          *ngIf="card$ | async as memberCard"
        >
          <span class="font-size-14">{{ memberCard?.ProductCodeDisplayName || membercard?.ProductCode }} </span>
          <div class="px-1">-</div>
          <span class="font-size-14">{{ memberCard.ExternalRefNumber }}</span>
        </div>
      </div>
    </div>

    <div class="right-nav-menu-list">
      <!-- Nav Buttons -->
      <div class="upper-nav-menu-list">
        <ng-container *inPopulation="[populations.Suite]">
          <a
            class="right-nav-menu-item"
            data-bs-dismiss="offcanvas"
            [routerLink]="['/faq']"
            [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <div class="content">
              <div class="nav-text">{{ 'nav.faq' | translate }}</div>
            </div>
          </a>
        </ng-container>

        <ng-container *inPopulation="[populations.Free, populations.Partner]">
          <a
            class="right-nav-menu-item"
            data-bs-dismiss="offcanvas"
            [routerLink]="['/account']"
            [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <div class="content">
              <div class="nav-text">{{ 'nav.account' | translate }}</div>
            </div>
          </a>
          <ng-container *inPopulation="populations.Partner">
            <a
              class="right-nav-menu-item"
              data-bs-dismiss="offcanvas"
              [routerLink]="['/partners']"
              [routerLinkActive]="'active'"
              [routerLinkActiveOptions]="{ exact: true }"
            >
              <div class="content">
                <div class="nav-text">{{ 'nav.partner' | translate }}</div>
              </div>
            </a>
          </ng-container>
          <a
            class="right-nav-menu-item"
            data-bs-dismiss="offcanvas"
            [routerLink]="['/referAFriend']"
            [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <div class="content">
              <div class="nav-text">{{ 'nav.refer.a.friend' | translate }}</div>
            </div>
          </a>
          <a
            class="right-nav-menu-item"
            data-bs-dismiss="offcanvas"
            [routerLink]="['/faq']"
            [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <div class="content">
              <div class="nav-text">{{ 'nav.faq' | translate }}</div>
            </div>
          </a>
          <a
            class="right-nav-menu-item"
            data-bs-dismiss="offcanvas"
            [routerLink]="['/terms']"
            [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <div class="content">
              <div class="nav-text">{{ 'nav.terms' | translate }}</div>
            </div>
          </a>
        </ng-container>

        <ng-container *inPopulation="[populations.Default]">
          <a
            class="right-nav-menu-item"
            data-bs-dismiss="offcanvas"
            [routerLink]="['/account']"
            [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <div class="content">
              <div class="nav-text">{{ 'nav.account' | translate }}</div>
            </div>
          </a>
          <a
            class="right-nav-menu-item"
            data-bs-dismiss="offcanvas"
            [routerLink]="['/partners']"
            [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <div class="content">
              <div class="nav-text">{{ 'nav.partner' | translate }}</div>
            </div>
          </a>
          <a
            class="right-nav-menu-item"
            data-bs-dismiss="offcanvas"
            [routerLink]="['/referAFriend']"
            [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <div class="content">
              <div class="nav-text">{{ 'nav.refer.a.friend' | translate }}</div>
            </div>
          </a>
          <a
            class="right-nav-menu-item"
            data-bs-dismiss="offcanvas"
            [routerLink]="['/faq']"
            [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <div class="content">
              <div class="nav-text">{{ 'nav.faq' | translate }}</div>
            </div>
          </a>

          <a
            class="right-nav-menu-item"
            data-bs-dismiss="offcanvas"
            [routerLink]="['/terms']"
            [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <div class="content">
              <div class="nav-text">{{ 'nav.terms' | translate }}</div>
            </div>
          </a>
        </ng-container>

        <a
          class="right-nav-menu-item"
          data-bs-dismiss="offcanvas"
          [routerLink]="['/contact']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <div class="content">
            <div class="nav-text">{{ 'nav.contact.us' | translate }}</div>
          </div>
        </a>

        <a class="right-nav-menu-item" data-bs-dismiss="offcanvas" href="{{ 'mlb.privacy.url' | translate }}">
          <div class="content">
            <div class="nav-text">{{ 'nav.privacy.policy' | translate }}</div>
          </div>
        </a>

        <a class="right-nav-menu-item" data-bs-dismiss="offcanvas" href="{{ 'mlb.terms.url' | translate }}">
          <div class="content">
            <div class="nav-text">{{ 'nav.terms.of.use' | translate }}</div>
          </div>
        </a>
      </div>

      <div class="bottom-nav-bar">
        <span class="font-size-14 m-0 text-white">{{ 'mobile.nav.copy.right' | translate }}</span>

        <a
          class="log-out text-white font-size-14 fw-bold d-flex flex-row align-items-center"
          data-bs-dismiss="offcanvas"
          (click)="logout()"
        >
          <i class="material-icons">logout</i>
          <div class="nav-text fw-bold">{{ 'nav.log.out' | translate }}</div>
        </a>
      </div>
    </div>
  </div>
</div>

<ng-template #memberDetailsLoading>
  <div class="user-box d-block text-center text-on-primary px-4 cursor-pointer">
    <fgbcl-loading [size]="'small'"></fgbcl-loading>
  </div>
</ng-template>
